module.exports = __webpack_public_path__ + "img/icon-fyzx.4afb87e8.png";